const createPreviewImage = (inputElement) => {
  var reader = new FileReader();
  reader.onload = function(event) {
    var theUrl;
    theUrl = event.target.result;
    $(inputElement)
      .parent()
      .append('<div class="photo-grid__image-preview" style="background-image: url(' + theUrl + ')" />');
    $(inputElement).parent().siblings('.photo-grid__uploaded-message').removeClass('hidden');
    $(inputElement).parent().addClass('attachment');
  };
  reader.readAsDataURL(inputElement.files[0]);
}

bcn.imageUploads = (function () {

  'use strict';

  function renderImage (fileField) {
    var reader = new FileReader();
    reader.onload = function(event) {
      var theUrl;
      theUrl = event.target.result;
      $(fileField)
        .parent()
        .append('<div class="photo-grid__image-preview" style="background-image: url(' + theUrl + ')" />');
    };
    reader.readAsDataURL(fileField.files[0]);
  }

  function clickFileInput (insertedItem) {
    var fileInput = insertedItem.find('input[type="file"]');
    if (fileInput.length) {
      fileInput.click();
    }
  }

  function addRef (insertedItem) {
    var hex = (Math.random().toString(36)+'00000000000000000').slice(2, 16+2);
    insertedItem.find('input[name^="tribute_fund[photos_attributes]"]').attr('data-reference', hex);
  }

  function oldBrowserFallback () {
    if (Modernizr.filereader) {
      return;
    }

    $('#photos').prepend('<h2 class="standard-sub-heading">Add photos here then click the Next button to save them.</h2>');
  }

  function showLoader (target, parentEl) {
    $(target).parents(parentEl).addClass('loading').append('<div class="bcn-loader" />');
  }

  function removeLoader (target, parentEl) {
    $(target).parents(parentEl).removeClass('loading').find('.bcn-loader').remove();
  }

  function listenForFileInputChangeEvents () {
    document.addEventListener("change", function(changeEvent) {

      if(changeEvent.target.tagName === "INPUT" && changeEvent.target.type === "file") {
        createPreviewImage(changeEvent.target);
      }
    });
  }

  function removeUpload (parentEl) {
    parentEl.removeClass('uploaded').find('img').attr('src', '');

    parentEl.find('input').each(function () {
      $(this).val('');
    });

    $('.photo-upload__uploaded-info').remove();
  }

  function singleUpload () {
    console.log('singleUpload');
    $('[data-upload-trigger]').on('click', function () {
      var parentEl = $(this).parents('[data-upload-image-type]');
      clickFileInput(parentEl);
    });

    $('body').on('click', '[data-upload-remove]', function () {
      var parentEl = $(this).parents('[data-upload-image-type]');
      var el = parentEl.length ? parentEl : $(this).parents('#event-photo-cached').next('[data-upload-image-type]');
      removeUpload(el);
      $('.photo-upload__preview-image').hide();
    });
  }

  function mulitpleUpload () {
    // Because cocoon appends the same html partial multiple times, and refile
    // relies on a unique reference to update the image id we need to give each
    // photo partial its own unique id so reifle doesnt just replace the id of the
    // first image every time
    $('#photos').on('cocoon:before-insert', function(e, insertedItem) {
      addRef(insertedItem);
    });

    $('#photos').on('cocoon:after-insert', function(e, insertedItem) {
      clickFileInput(insertedItem);
    });
  }

  function groupPrimaryRadioButtons() {
    $('#photos').on('click', "[data-radio-group='primary']", function(e) {
      $("[data-radio-group='primary']").prop('checked', false);
      $(e.currentTarget).prop('checked', true)
    });
  }

  return {
    init: function () {
      var isMultipleUpload = false;
      var parentEl;
      var imageUploadContainer = $('[data-upload-image-type]');

      if (!imageUploadContainer.length) {
        return;
      }

      isMultipleUpload = imageUploadContainer.data('upload-image-type') === 'multiple';
      parentEl = isMultipleUpload ? '.attachment' : '[data-upload-image-type]';

      groupPrimaryRadioButtons();
      listenForFileInputChangeEvents();

      if (isMultipleUpload) {
        oldBrowserFallback();
        mulitpleUpload();
        return;
      }

      singleUpload();
    }
  };

})();

